module.exports = __webpack_public_path__ + "gb.svg?c0af635097d429c21cdd7ea7636d40d5";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gb.svg
// module id = 810
// module chunks = 27